// src/data/certifications.js

export const CERTIFICATIONS = [
  {
    name: 'AWS Certified Cloud Practitioner',
    image: '/certification_images/AWS_CCP.jpg',
    link: 'https://www.credly.com/badges/f357a971-65cd-40a9-b6b8-81f0b2f3cad4/public_url',
  },
  {
    name: 'PMI Project Management Ready',
    image: '/certification_images/PMI_Ready.png',
    link: 'https://drive.google.com/file/d/1LB-q73Zv1z1x1QQVzUmTvNxgIMheejAq/view?usp=sharing',
  },
  {
    name: 'Microsoft Office Specialist - Excel 2019 Associate',
    image: '/certification_images/Excel_2019.png',
    link: 'https://drive.google.com/file/d/1Nyc-KmcZPTpczMJFxrFQHSTTFY1LYQPA/view?usp=sharing',
  },
  {
    name: 'Microsoft Certified: Azure Fundamentals',
    image: '/certification_images/Azure.png',
    link: 'https://drive.google.com/file/d/1zpOodXG_dgHEaG-5hF6zhBjlLq7DumnV/view?usp=sharing',
  },  
  {
    name: 'NUS Alumni Ambassador',
    image: '/certification_images/Ambassador.png',
    link: 'https://credentials.nus.edu.sg/3cc68885-f206-4a04-bcb1-1b5cd82cac5a#acc.utwU9RQd',
  },
  {
    name: 'Game Technical Design - Unreal Engine',
    image: '/certification_images/Unreal.png',
    link: 'https://www.accredify.io/verify?id=b0ba7546-60f9-4b4b-a792-37be3da0bb04',
  },
  {
    name: 'Indie Game Development - Unity',
    image: '/certification_images/Unity.png',
    link: 'https://www.accredify.io/verify?id=71f6c258-c4a9-440e-8596-9f6c30ee1cc6',
  },
  {
    name: 'Drawing: An Introduction',
    image: '/certification_images/lasalle.png',
    link: 'https://drive.google.com/file/d/1Ao9aG7Ub7f2QQsNOI86QWQx4AFD2_Y6F/view',
  },
];
